import { gql } from "@apollo/client";

export const GET_ARCHIVE_FOLDER_BY_INBOX = gql`
	query getArchiveFolderByInbox($inboxId: Int!) {
		msgbox_Folder(
			where: { InboxId: { _eq: $inboxId }, IsArchive: { _eq: true } }
		) {
			FolderId
		}
	}
`;

export const GET_FOLDERS_IN_INBOX = gql`
	query getFoldersInInbox($inboxId: Int!) {
		msgbox_Folder(
			where: { InboxId: { _eq: $inboxId } }
			order_by: { FolderId:asc }
		) {
			Name
			IsArchive
			FolderId
		}
	}
`;


export const BULK_MOVE_TO_ARCHIVE = gql`
	mutation bulkMoveToArchive(
		$conversationIds: [Int!]!
		$archiveId: Int!
	) {
		update_msgbox_Conversation(
			where: { ConversationId: { _in: $conversationIds } }
			_set: { FolderId: $archiveId, UpdatedOn: "now()" }
		) {
			affected_rows
		}
	}
`;

export const BULK_RESTORE_FROM_ARCHIVE = gql`
	mutation bulkRestoreFromArchive(
		$conversationIds: [Int!]!
		$folderId: Int!
	) {
		update_msgbox_Conversation(
			where: { ConversationId: { _in: $conversationIds } }
			_set: { FolderId: $folderId, UpdatedOn: "now()" }
		) {
			affected_rows
		}
	}
`

export const GET_DEPARTMENT_ID = gql`
	query getDepartmentId($userId: Int!) {
		msgbox_User(where: { UserId: { _eq: $userId } }) {
			DepartmentId
			UserId
		}
	}
`;

export const GET_AI_USERS = gql`
	query getAIUsers {
		msgbox_User(
			where: { IsAIBot: { _eq: true }, IsDeleted: { _eq: false } }
			order_by: { FirstName: asc }
		) {
			UserId
			FirstName
			LastName
		}
	}
`;

export const GET_INBOX_DATA = gql`
	query getInboxData($userId: Int) {
		msgbox_User(where: { UserId: { _eq: $userId } }) {
			UserId
			UserInboxes {
				Inbox {
					InboxId
					Name
					Folders (order_by: {FolderId:desc}) {
						FolderId
						Name
					}
				}
			}
		UserDepartments {
			Department {
				DepartmentId
				DepartmentInboxes (order_by:{InboxId:desc}) {
					Inbox {
						InboxId
						Name
					}
				}
				Name
			}
		}
		}
	}
`;

export const SEARCH_CONVERSATIONS_MULTISELECT = gql`
	query searchConversationsMultiSelect(
		$searchTerm: String!
		$userInboxes: [Int!]
		$userId: Int!
	) {
		msgbox_Contact(
			where: {
				APIAccount: { Inboxes: { InboxId: { _in: $userInboxes } } }
				_or: [
					{ Name: { _ilike: $searchTerm } }
					{ MobileNumber: { _ilike: $searchTerm } }
				]
			}
		) {
			ContactId
			Name
		}
		msgbox_Department(
			where: {
				UserDepartments: { UserId: { _eq: $userId } }
				Name: { _ilike: $searchTerm }
			}
		) {
			DepartmentId
			Name
		}
		msgbox_User(
			where: {
				IsBot: { _eq: false }
				IsAPI: { _eq: false }
				UserRoles: { Role: { Name: { _is_null: false } } }
				_or: [
					{ FirstName: { _ilike: $searchTerm } }
					{ LastName: { _ilike: $searchTerm } }
				]
			}
		) {
			FirstName
			UserId
			LastName
		}
		msgbox_Tag(where: { Name: { _ilike: $searchTerm } }) {
			Name
			TagId
		}
	}
`;
